import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App.tsx";
import { store } from "./store/index.ts";
import "./styles/globals.css";

import "@rainbow-me/rainbowkit/styles.css";

import {
  getDefaultConfig,
  RainbowKitProvider,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import { WagmiProvider } from "wagmi";
import { bsc } from "wagmi/chains"; // Import only BSC Mainnet
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

// WAGMI v2 CONFIGURATION
const config = getDefaultConfig({
  appName: "My RainbowKit App",
  projectId: "123456f97ff6e43783f84f7908c325c9", // Remember to use your actual Project ID from WalletConnect Cloud
  chains: [bsc], // ✅ Set chains to only BSC Mainnet
  ssr: true,
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: "#facc15", // your yellow
            accentColorForeground: "#2f2e2e", // black text
            borderRadius: "large",
            fontStack: "system",
          })}
        >
          <Provider store={store}>
            <App />
          </Provider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// import React from "react";
// import ReactDOM from "react-dom/client";
// import { Provider } from "react-redux";
// import App from "./App.tsx";
// import { store } from "./store/index.ts";
// import "./styles/globals.css";

// import "@rainbow-me/rainbowkit/styles.css";

// import {
//   getDefaultConfig,
//   RainbowKitProvider,
//   darkTheme, // ✅ import theme
// } from "@rainbow-me/rainbowkit";
// import { WagmiProvider } from "wagmi";
// import { mainnet, polygon, optimism, arbitrum, base } from "wagmi/chains";
// import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

// // WAGMI v2 CONFIGURATION
// const config = getDefaultConfig({
//   appName: "My RainbowKit App",
//   projectId: "123456f97ff6e43783f84f7908c325c9",
//   chains: [mainnet, polygon, optimism, arbitrum, base],
//   ssr: true,
// });

// const queryClient = new QueryClient();

// ReactDOM.createRoot(document.getElementById("root")!).render(
//   <React.StrictMode>
//     <WagmiProvider config={config}>
//       <QueryClientProvider client={queryClient}>
//         <RainbowKitProvider
//           // ✅ Apply custom theme here
//           theme={darkTheme({
//             accentColor: "#facc15", // your yellow
//             accentColorForeground: "#2f2e2e", // black text
//             borderRadius: "large",
//             fontStack: "system",
//           })}
//         >
//           <Provider store={store}>
//             <App />
//           </Provider>
//         </RainbowKitProvider>
//       </QueryClientProvider>
//     </WagmiProvider>
//   </React.StrictMode>
// );
